import React from "react"
import "./HowItWorks.css"

const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      title: "Book Your Consultation",
      description:
        "Book a 20-min call and let us walk you through the $13.7M proven model, have an exploratory conversation to assess how your skills and experience could translate to running your own IT staffing company.",
      icon: "📞",
    },
    {
      number: "2",
      title: "Qualify & Claim Territory",
      description:
        "Join us in Omaha for a Discovery Day. Tour the founding office, meet the leadership team, and see exactly how the business runs. When you're ready, pick your protected territory and sign the agreement.",
      icon: "🏢",
    },
    {
      number: "3",
      title: "Launch in 90 Days",
      description:
        "We give you a launch checklist. You complete live training, set up the software, start local marketing, and open your doors. We'll work with you to make your first placement within the first 90 days.",
      icon: "🚀",
    },
    {
      number: "4",
      title: "Run Your Company",
      description:
        "Plug in our proven systems and support to fill IT jobs and collect placement fees. Happy clients turn into repeat requisitions, extensions, and bigger budgets. Scale your business and lock in additional territories.",
      icon: "💼",
    },
  ]

  const scrollToBooking = () => {
    const element = document.getElementById("booking-form")
    const headerOffset = 80 // Account for sticky header height to land exactly at green background start
    const elementPosition = element.offsetTop
    const offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  return (
    <section className='how-it-works-section section section-green'>
      <div className='container'>
        <div className='animate-fade-up'>
          <h2 className='section-title'>How It Works</h2>
          <p className='section-subtitle'>
            Our proven 4-step process takes you from consultation to running
            your own successful IT staffing company
          </p>
        </div>

        <div className='steps-container'>
          {steps.map((step, index) => (
            <div
              key={index}
              className='step-card animate-fade-up'
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className='step-number'>{step.number}</div>
              <div className='step-content'>
                <div className='step-icon'>{step.icon}</div>
                <h3 className='step-title'>{step.title}</h3>
                <p className='step-description'>{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className='how-it-works-cta animate-fade-up'
          style={{ animationDelay: "1s" }}
        >
          <h3 className='cta-title'>Ready to get started?</h3>
          <button className='btn-primary' onClick={scrollToBooking}>
            Schedule a 20-Minute Evaluation Call
          </button>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
